// extracted by mini-css-extract-plugin
export default {"container":"s02_container__Zawyi","wrapper":"s02_wrapper__-jotd"};